export default "__VITE_PUBLIC_ASSET__e90e8a6e__"